module.exports = __webpack_public_path__ + "static/img/14.c8a753c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/1/sp/14.png
// module id = Fc63
// module chunks = 0